<div class="sidebar-wrapper" data-simplebar="true">
    <div class="sidebar-header">
        <div>
            <img src="assets/images/logo_icon.png" class="logo-icon" alt="logo icon">
        </div>
        <div>
            <img src="assets/images/logo.png" class="logo-n-ic logo-text" alt="logo">
        </div>
        <div class="toggle-icon ms-auto">
            <!-- <i class='bx bx-arrow-to-left'></i> -->
            <i class='bx bx-menu'></i>
        </div>
    </div>
    <!--navigation-->
    <ul class="metismenu sidebar-menu" id="menu">
        <li routerLinkActive="mm-active"> 
            <a routerLink='/dashboard'  >
                <div class="parent-icon"><i class='bx bx-home-circle'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.DASHBOARD'"> </span></div>
            </a>
        </li>
        <!-- <li>
            <a class="has-arrow" href="javascript:void(0)">
                <div class="parent-icon"><i class="bx bx-key"></i>
                </div>
                <div class="menu-title" (click)="views(2)"><span [translate]="'GREATER.ACCOUNT_MASTER'"> </span></div>
            </a>
            <ul *ngIf="showData1">
                <li> <a routerLink="/users"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.USERS'"> </span></a>
                </li>
                <li> <a routerLink="/creators"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.CREATORS'"> </span></a>
                </li>
                <li> <a routerLink="/organisations"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.ORGANISATIONS'"> </span></a>
                </li>
                <li> <a routerLink="/deleted-user"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.DELETED_USER'"> </span></a>
                </li>               
            </ul>
        </li> -->
        <li routerLinkActive="mm-active">
            <a routerLink="/users"  >
                <div class="parent-icon"><i class='bx bx-user-circle'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.USERS'"> </span></div>  
            </a>
        </li>  
        <li routerLinkActive="mm-active">
            <a routerLink="/creators"  >
                <div class="parent-icon"><i class='bx bx-badge-check'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.CREATORS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/organisations">
                <div class="parent-icon"><i class='bx bx-briefcase'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.ORGANISATIONS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/deleted-user">
                <div class="parent-icon"><i class='bx bx-badge-check'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.DELETED_USER'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/transaction"  >
                <div class="parent-icon"><i class='bx bx-user-circle'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.MANAGE_TRANSACTION'"> </span></div>  
            </a>
        </li>
        <li>
            <a routerLink="/app-version">
                <div class="parent-icon">
                    <i class='bx bx-message-square-edit'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.MANAGE_APP_VERSION'"> </span></div>
            </a>
        </li>
        
        
        <li routerLinkActive="mm-active">
            <a routerLink="/collabrator">
                <div class="parent-icon"><i class='bx bx-badge-check'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.COLLABRATORS'"> </span></div>
            </a>
        </li>
      
        <li routerLinkActive="mm-active">
            <a routerLink="/programs">
                <div class="parent-icon"><i class='bx bx-code-block'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.PROGRAMS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/albums">
                <div class="parent-icon"><i class='bx bx-images'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.ALBUMS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/single-content">
                <div class="parent-icon"><i class='bx bx-edit'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.CONTENT_POSTS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/referal">
                <div class="parent-icon"><i class="bx bx-notepad"></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.REFERALS'"> </span></div>
            </a>
        </li>
       
        <li routerLinkActive="mm-active">
            <a routerLink="/report">
                <div class="parent-icon"><i class='bx bx-badge-check'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.REPORT'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/feedback">
                <div class="parent-icon"><i class='bx bx-badge-check'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.FEEDBACKS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/reset-link">
                <div class="parent-icon"><i class="bx bx-notepad"></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.RESET_LINK'"> </span></div>
            </a>
        </li>

        <li routerLinkActive="mm-active">
            <a routerLink="/static-page">
                <div class="parent-icon"><i class="bx bx-notepad"></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.STATIC_PAGES'"> </span></div>
            </a>
        </li>

        <li routerLinkActive="mm-active">
            <a routerLink='/faq'>
                <div class="parent-icon"><i class='bx bx-info-circle'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.FAQ'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink='/web-media'>
                <div class="parent-icon"><i class='bx bx-slideshow'></i>
                </div>
                <div class="menu-title">Web Media</div>
            </a>
        </li>
        <li>
            <a class="has-arrow" href="javascript:void(0)">
                <div class="parent-icon"><i class="bx bx-lock"></i>
                </div>
                <div class="menu-title" (click)="views(1)"><span [translate]="'GREATER.MASTER_DATA_MANAGEMENT'"> </span></div>
            </a>
            <ul *ngIf="showData">
                <li routerLinkActive="mm-active"> <a routerLink="/reasons"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.REASON'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/ability"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.ABILITY'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/primary-category"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.PRIMARY_CATEGORY'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/content-piller"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.CONTENT_PILLAR'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/level"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.LEVEL'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/medical"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.MEDICAL_CONDITION'"> </span></a>
                </li>
                <!-- <li routerLinkActive="mm-active"> <a routerLink="/location"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.WELLNESS_LOCATION'"> </span></a>
                </li> -->
                <!-- <li routerLinkActive="mm-active"> <a routerLink="/suitability"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.SUITABILITY'"> </span></a>
                </li> -->
                <li routerLinkActive="mm-active"> <a routerLink="/diet"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.DIET'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/race"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.RACE'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/subcategory"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.SUB_CATEGORIES'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/demographic"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.DEMOGRAPHIC'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/primary-piller"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.PROFILE_BACKGROUND'"> </span></a>
                </li>
                <!-- 

               
                <li routerLinkActive="mm-active"> <a routerLink="/rejectorder"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.ORDER_REJECTED'"> </span></a>
                </li>
                <li routerLinkActive="mm-active"> <a routerLink="/rejectorder"><i class="bx bx-right-arrow-alt"></i><span [translate]="'GREATER.ORDER_REJECTED'"> </span></a>
                </li>-->
            </ul>
        </li>



    </ul>
    <!--end navigation-->
</div>
